const pix = {
  PIX_INVALID_KEY_TYPE: {
    message: 'Invalid PIX key type'
  },
  PIX_KEY_INVALID_EMAIL: {
    message: 'The email must be valid'
  },
  PIX_KEY_INVALID_DOCUMENT: {
    message: 'Provided document is not a CPF nor CNPJ'
  },
  PIX_KEY_INVALID_PHONE: {
    message: 'The phone number must be valid'
  },
  PIX_KEY_DUPLICATED: {
    message: 'Provided PIX key already exists'
  },
  PIX_KEY_INVALID_VERIFICATION_CODE: {
    message: 'Invalid verification code for PIX key'
  },
  PIX_MAX_KEY_LIMIT_EXCEEDED: {
    message: 'PIX key limit exceeded (5)'
  },
  INVALID_DATE_FORMAT: {
    message: 'Invalid date format'
  },
  MIN_VALUE: {
    message: 'The value must not be lower than R$0,00'
  },
  PAYER_INVALID_PERSON_TYPE: {
    message: "The payer's type must be valid"
  },
  PAYER_INVALID_DOCUMENT: {
    message: "The payer's document is not a CPF or CNPJ"
  },
  PAYER_INVALID_NAME: {
    message: "The payer's name must be valid"
  },
  PAYER_INVALID_EMAIL: {
    message: "The payer's email must be valid"
  },
  PAYER_INVALID_PHONE: {
    message: "The payer's phone number must be valid"
  },
  PIX_KEY_NOT_FOUND: {
    message: 'Pix key not found'
  },
  UNABLE_TO_SEND_PIX_TO_SALARY_ACCOUNT: {
    message: 'Unable to send PIX to salary account'
  },
  QRCODE_INVALID_DATE: {
    message: 'Invalid date'
  },
  PIX_KEY_IN_CLAIM_PROCESS: {
    message:
      'This key is already registered and is in the process of being claimed. You will not be able to register it until the process is finished.'
  },
  CANT_DELETE_KEYS_IN_CLAIM_PROCESS: {
    message: 'You cannot delete keys that are in the claim process. Wait for the process to complete'
  },
  INVALID_STATUS_TO_START_A_CLAIM_PROCESS: {
    message: 'Key status does not allow to start a claim process'
  },
  INVALID_STATUS_TO_CANCEL_THE_CLAIM_PROCESS: {
    message: 'Key status does not allow to cancel the claim process'
  },
  INVALID_STATUS_TO_CONFIRM_THE_CLAIM_PROCESS: {
    message: 'Key status does not allow to confirm the claim process'
  },
  CLAIM_ALREADY_EXISTS_FOR_KEY: {
    message: 'There is already an ongoing claim process for this key'
  }
};

module.exports = pix;
